import React from 'react';

import type { ImageProps } from 'src/shared/components/Image';
import { Image } from 'src/shared/components/Image';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

import homeownerHouse from 'assets/img/signup-homeowner.png';
import homeownerHouseWebP from 'assets/img/signup-homeowner.webp';

const HomeownerImage = (props: Omit<ImageProps, 'alt'>) => (
  <Image
    alt={useTranslate(TranslationNamespace.SIGN_UP)(
      'screenReaderHouseWithTextures',
    )}
    boxSizing="border-box"
    maxHeight="721px"
    src={homeownerHouse}
    webp={homeownerHouseWebP}
    {...props}
  />
);

export { HomeownerImage };
